import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";

import ic_delete from "../assets/images/ic_delete.svg";
import ic_edit from "../assets/images/ic_edit.svg";
import ic_eyes from "../assets/images/ic_eyes.svg";
import Modal from "react-bootstrap/Modal";
import {
  DeleteCallWithErrorResponse,
  multipartPostCallWithErrorResponse,
  PostCallWithAuthTokenWithErrorResponse,
  putMultipartWithAuthCallWithErrorResponse,
  simpleGetCallWithErrorResponse,
} from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import {
  DEFAULT_LANG,
  DEFAULT_LANG_LABEL,
  LANGUAGES,
  buildSabaqFormData,
  dirOf,
  emptySabaq,
  emptySubSabaq,
  getLanguage,
  isDefaultLangBlank,
  mapSabaqResponse,
} from "../api/multiLang";
import { ToastMsg } from "./TostMsg";
import { Pagination } from "./Pagination";
import FormLoader from "./FormLoader";
import Tabs from "../sharedComponents/Tabs";


const UmrahHajj = () => {
  const [AddNewGroup, setAddNewGroup] = useState(0);
  const [idEdit, setIdEdit] = useState("");
  const [viewDetails, setViewDetails] = useState([]);
  const { sidebar, adminData } = useContext(AppContext);
  const [loader, setLoader] = useState(true);
  const [lasatSabaqId, setLsatSabaq] = useState("");
  const[saveBotton, setSaveBotton] =useState(false);


  const [umrahList, setUmrahList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const startIndex = currentPage * 15;
  const endIndex = startIndex + 15;
  const changePage = ({ selected }) => {
    setCurrentPage(selected);
  };
  const pageCount = Math.ceil(umrahList?.length / 15);
  const [imageWidth, setImageWidth] = useState({
    sabaqAudio: "100%",
    Uploade: "100%",
    Tarjama: "100%",
    Description: "100%",
    subSabaqTitle: "100%",
  });
  const [deleteId, setDeleteId] = useState("");
  const [addNamaz, setAddNamaz] = useState(emptySabaq());
  const [activeLang, setActiveLang] = useState(DEFAULT_LANG);

  // Field names for the language tab currently being edited.
  // The API keys every field by a language suffix, with the unsuffixed field
  // holding the default text.
  const activeLangMeta = getLanguage(activeLang);
  const langSuffix = activeLangMeta.suffix;
  const activeLangLabel = activeLangMeta.label;
  const isDefaultLang = activeLang === DEFAULT_LANG;
  const textDir = dirOf(activeLang);

  const nameKey = `sabaqName${langSuffix}`;
  const nameAudioKey = `sabaqNameAudio${langSuffix}`;
  const descKey = `sabaqDesc${langSuffix}`;
  const descAudioKey = `sabaqDescAudio${langSuffix}`;
  const referenceKey = `sabaqDescReference${langSuffix}`;

  // One shared set of sub sabaq rows; the language only changes which field on
  // each row is being edited.
  const subSabaqKey = "subSabaq";
  const currentSubSabaq = addNamaz[subSabaqKey] || [];
  const subTitleKey = `subSabaqTitle${langSuffix}`;
  const subTitleAudioKey = `subSabaqTitleAudio${langSuffix}`;
  const subDescKey = `subSabaqDesc${langSuffix}`;
  const subDescAudioKey = `subSabaqDescAudio${langSuffix}`;
  const subReferenceKey = `subSabaqDescReference${langSuffix}`;



  const [add, setAdd] = useState(false);
  const handleAddClose = () => {
    setAddNamaz(emptySabaq());
    setIdEdit("");
    setAdd(false);
    setValidated(false);
    setActiveLang(DEFAULT_LANG);
  };
    const handleAddShow = () => setAdd(true);

  const [deleteModal, setDelete] = useState(false);
  const handleDeleteClose = () => setDelete(false);
  const handleDeleteShow = () => setDelete(true);

  const [viewModal, setView] = useState(false);
  const handleViewClose = () => setView(false);
  const handleViewShow = () => setView(true);

  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;

    event.preventDefault();

    // The required fields live on the default language tab, and only the
    // open tab is mounted -- so a blank one is invisible to checkValidity
    // from any other tab. Read the state and send the admin back there.
    if (isDefaultLangBlank(addNamaz, "sabaqName")) {
      event.stopPropagation();
      setValidated(true);
      if (!isDefaultLang) {
        setActiveLang(DEFAULT_LANG);
        ToastMsg("error", `Please Enter Sabaq Name (${DEFAULT_LANG_LABEL})`);
      }
      return;
    }
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      addumrahaajApi();
    }

    setValidated(true);
  };

  const addumrahaajApi = () => {
    handleAddClose();
    setLoader(true);

    const payLoadFormData = buildSabaqFormData({
      form: addNamaz,
      categoryId: 7,
      userId: Number(adminData.user_id),
      isEdit: idEdit === "edit",
      sabaqNo: lasatSabaqId + 1,
    });

    idEdit === "edit"
      ? putMultipartWithAuthCallWithErrorResponse(
          ApiConfig.SUBAQUPDATE,
          payLoadFormData
        ).then((res) => {
          
          setSaveBotton(false)

          if (res.json && res.json?.success === true) {
            ToastMsg("success", res.json.message);
            umarahListApi();
 

         
          } else {
            ToastMsg("error", res.json.message);
          }
        })
        .catch((err) => {
          setLoader(false);

          ToastMsg("error", "something went wrong");
        })
      : multipartPostCallWithErrorResponse(
          ApiConfig.SUBAQADDALL,
          payLoadFormData
          // payLoadFormDataNew
        )
          .then((res) => {
         
            setSaveBotton(false)

            if (res.json && res.json?.success === true) {
              ToastMsg("success", res.json.message);
              umarahListApi();
   

            
            } else {
              ToastMsg("error", res.json.message);
            }
          })
          .catch((err) => {
            setLoader(false);

            ToastMsg("error", "something went wrong");
          });
  };
  //
  useEffect(() => {
    umarahListApi();
  }, []);
  const umarahListApi = () => {
    simpleGetCallWithErrorResponse(ApiConfig.SUBAQLIST + `?categoryId=${7}`)
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
 
          setUmrahList(res.json.data.allSabaq);
          setLsatSabaq(
            res.json?.data.allSabaq.length
          );
          // pagination();
          // ToastMsg("success", res.json.message);
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };

  const umrahLisDeleteApi = () => {
    const body = {
      categoryId: 7,

      sabaqId: deleteId,
    };
    // setIsLoading(true);
    DeleteCallWithErrorResponse(
      ApiConfig.DELETEAPI,

      JSON.stringify({
        ...body,
      })
    )
      .then((res) => {
        setLoader(false);
        handleDeleteClose();
        if (res.json && res.json?.success === true) {
          // setSabaqList(res.json.data);
          umarahListApi();
          ToastMsg("success", res.json.message);
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };

  const EditListApi = (id) => {

    // setIsLoading(true);
  
      
    

    simpleGetCallWithErrorResponse(ApiConfig.EDITALL + `?sabaqId=${id}`)
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          setAddNamaz(mapSabaqResponse(res.json?.data));
          setIdEdit("edit");
          handleAddShow();
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };

  //testing function
  //view the
  const viewDetailshandle = (id) => {
    simpleGetCallWithErrorResponse(ApiConfig.EDITALL + `?sabaqId=${id}`)
      .then((res) => {
        setLoader(false);

        if (res.json && res.json?.success === true) {
          setViewDetails(res.json.data);
          handleViewShow();
          // ToastMsg("success", res.json.message);
        } else {
          ToastMsg("error", res.json.message);
        }
      })
      .catch((err) => {
        setLoader(false);

        ToastMsg("error", "something went wrong");
      });
  };

  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="heading-btn-main">
        <div className="heading-common">
          <label htmlFor="">Umrah & Hajj</label>
        </div>
        <div className="add-btn">
          <button onClick={handleAddShow}>
            Add Sabaq
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path fill="white" d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z" />
            </svg>
          </button>
        </div>
      </div>
      {/* ======================= START ADD ========================== */}
      <Modal
        show={add}
        // onHide={handleAddClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton         onHide={handleAddClose}
>
          {/* <Modal.Title>Add Umrah & Hajj</Modal.Title> */}
          <Modal.Title>{idEdit==="edit"?"Update Umrah & Hajj":"Add Umrah & Hajj"}</Modal.Title>

        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="row">

              {/* One ordering for the whole record, not per language, so it
                  sits above the language tabs. */}
              <div className="col-md-6 mb-3">
                <Form.Label>Order No</Form.Label>
                <Form.Control
                  type="number"
                  min="1"
                  value={addNamaz?.orderNo}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, orderNo: e.target.value })
                  }
                />
              </div>
              <div className="col-md-12 sub-group-main">
                <Tabs
                  tabs={LANGUAGES}
                  activeKey={activeLang}
                  onChange={(key) => setActiveLang(key)}
                />
                <div className="row">
              <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Name ({activeLangLabel})</Form.Label>
                <Form.Control
                  type="text"
                  required={isDefaultLang}
                  dir={textDir}
                  value={addNamaz?.[nameKey]}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, [nameKey]: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Sabaq Name
                </Form.Control.Feedback>
              </div>
         
                  {idEdit ? (
                <>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Audio ({activeLangLabel})
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.[nameAudioKey] === "string"
                          ? addNamaz?.[nameAudioKey].substring(
                              addNamaz?.[nameAudioKey].length - 15,
                              addNamaz?.[nameAudioKey].length
                            )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        key={nameAudioKey}
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqAudio"
                        style={{ width: imageWidth.sabaqAudio }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, sabaqAudio: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            [nameAudioKey]: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                </>
              ) : (
                <div className="col-md-12 mb-3">
                  <Form.Label>Sabaq Audio ({activeLangLabel})</Form.Label>
                  <Form.Control
                    key={nameAudioKey}
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqAudio"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        [nameAudioKey]: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
              )}
              <div className="col-md-12 mb-3">
                <Form.Label> Sabaq Description ({activeLangLabel})</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  dir={textDir}
                  value={addNamaz?.[descKey]}
                  onChange={(e) =>
                    setAddNamaz({ ...addNamaz, [descKey]: e.target.value })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Description.
                </Form.Control.Feedback>
              </div>
             
                  {idEdit ? (
                <>
                  <div className="row d-flex">
                    <div className="col-md-12">
                      <label htmlFor="" className="key">
                        Sabaq Description Audio ({activeLangLabel})
                      </label>
                    </div>
                    <div
                      className={imageWidth === "100%" ? "d-none" : "col-md-6 "}
                    >
                      <Form.Label>
                        {typeof addNamaz?.[descAudioKey] === "string"
                          ? addNamaz?.[descAudioKey].substring(
                              addNamaz?.[descAudioKey].length - 15,
                              addNamaz?.[descAudioKey].length
                            )
                          : ""}
                      </Form.Label>
                    </div>
                    <div className="col-md-12 mb-3 ">
                      <Form.Control
                        key={descAudioKey}
                        type="file"
                        accept="audio/mp3,audio/*;capture=microphone"
                        name="sabaqDescAudio"
                        style={{ width: imageWidth.Uploade }}
                        onChange={(e) => {
                          setImageWidth({ ...imageWidth, Uploade: "100%" });
                          setAddNamaz({
                            ...addNamaz,
                            [descAudioKey]: e.target.files[0],
                          });
                        }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Sabaq Name
                      </Form.Control.Feedback>
                    </div>
                  </div>
                </>
              ) : (
                <div className="col-md-12 mb-3">
                  <Form.Label>
                    Sabaq Description Audio ({activeLangLabel})
                  </Form.Label>
                  <Form.Control
                    key={descAudioKey}
                    type="file"
                    accept="audio/mp3,audio/*;capture=microphone"
                    name="sabaqImagePath"
                    //  / value={addSabaq?.sabaqAudio}
                    onChange={(e) =>
                      setAddNamaz({
                        ...addNamaz,
                        [descAudioKey]: e.target.files[0],
                      })
                    }
                  />

                  <Form.Control.Feedback type="invalid">
                    Please Enter Sabaq Name
                  </Form.Control.Feedback>
                </div>
              )}

              <div className="col-md-12 mb-3">
                <Form.Label>Sabaq Reference ({activeLangLabel})</Form.Label>
                <Form.Control
                  type="text"
                  dir={textDir}
                  value={addNamaz?.[referenceKey]}
                  onChange={(e) =>
                    setAddNamaz({
                      ...addNamaz,
                      [referenceKey]: e.target.value,
                    })
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Reference
                </Form.Control.Feedback>
              </div>
                </div>
              </div>

              {currentSubSabaq &&
                currentSubSabaq.map((elementInArray, index) => {
                  return (
                    <div
                      className="col-md-12 sub-group-main"
                      key={"testkey" + activeLang + index}
                    >
                      <div className="row">
                        <h6 className="fw-bold">Sub Sabaq Details</h6>
                        <div className="col-md-12 mb-3">
                          <Form.Label>
                          Sub Sabaq Title <span>{index + 1}</span> (
                            {activeLangLabel})
                          </Form.Label>
                          <Form.Control
                            type="text"
                            dir={textDir}
                            value={elementInArray?.[subTitleKey]}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                [subSabaqKey]: currentSubSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                          ...item,
                                          [subTitleKey]: e.target.value,
                                        }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sabaq Name
                          </Form.Control.Feedback>
                        </div>
                        {/* <div className="col-md-6 mb-3">
                          <Form.Label>Title Audio</Form.Label>
                          <Form.Control
                            type="file"
                            value={elementInArray?.[subTitleAudioKey]}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                [subSabaqKey]: currentSubSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                          ...item,
                                          [subTitleAudioKey]: e.target.files[0],
                                        }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sabaq Name
                          </Form.Control.Feedback>
                        </div> */}

{idEdit ? (
                          <>
                            <div className="row d-flex">
                              <div className="col-md-12">
                                <label htmlFor="" className="key">
                                  Sub Sabaq Title Audio ({activeLangLabel})
                                </label>
                              </div>
                              <div
                                className={
                                  imageWidth === "100%" ? "d-none" : "col-md-6 "
                                }
                              >
                                <Form.Label>
                                  {typeof elementInArray?.[subTitleAudioKey] ===
                                  "string"
                                    ? elementInArray?.[subTitleAudioKey].substring(
                                        elementInArray?.[subTitleAudioKey]
                                          .length - 15,
                                        elementInArray?.[subTitleAudioKey]
                                          .length
                                      )
                                    : ""}
                                </Form.Label>
                              </div>
                              <div className="col-md-12 mb-3 ">
                                <Form.Control
                                  type="file"
                                  accept="audio/mp3,audio/*;capture=microphone"
                                  name="subSabaqTitleAudio"
                                  style={{ width: imageWidth.subSabaqTitle }}
                                  //  value={addSabaq?.sabaqAudio}
                                  // onChange={(e) => {
                                  //   setImageWidth({ ...imageWidth, Description: "100%" });
                                  //   setAddSabaq({
                                  //     ...addSabaq,
                                  //     sabaqAudio: e.target.files[0],
                                  //   });
                                  // }}
                                  onChange={(e) => {
                                    setImageWidth({
                                      ...imageWidth,
                                      subSabaqTitle: "100%",
                                    });
                                    setAddNamaz({
                                      ...addNamaz,
                                      [subSabaqKey]: currentSubSabaq.map(
                                        (item, innerIndex) => {
                                          return index === innerIndex
                                            ? {
                                                ...item,
                                                [subTitleAudioKey]:
                                                  e.target.files[0],
                                              }
                                            : item;
                                        }
                                      ),
                                    });
                                  }}
                                />

                                <Form.Control.Feedback type="invalid">
                                  Please Enter Sabaq Name
                                </Form.Control.Feedback>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="col-md-12 mb-3">
                            <Form.Label>
                              Sub Sabaq Title Audio ({activeLangLabel})
                            </Form.Label>
                            <Form.Control
                              type="file"
                              accept="audio/mp3,audio/*;capture=microphone"
                              name="sabaqImagePath"
                              //  / value={addSabaq?.sabaqAudio}
                              onChange={(e) => {
                                setAddNamaz({
                                  ...addNamaz,
                                  [subSabaqKey]: currentSubSabaq.map(
                                    (item, innerIndex) => {
                                      return index === innerIndex
                                        ? {
                                            ...item,
                                            [subTitleAudioKey]:
                                              e.target.files[0],
                                          }
                                        : item;
                                    }
                                  ),
                                });
                              }}
                            />

                            <Form.Control.Feedback type="invalid">
                              Please Enter Sabaq Name
                            </Form.Control.Feedback>
                          </div>
                        )}
                        <div className="col-md-12 mb-3">
                          <Form.Label>
                            Sub Sabaq Description ({activeLangLabel})
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            dir={textDir}
                            value={elementInArray?.[subDescKey]}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                [subSabaqKey]: currentSubSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                          ...item,
                                          [subDescKey]: e.target.value,
                                        }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Aqaaid Description.
                          </Form.Control.Feedback>
                        </div>
                        {/* <div className="col-md-12 mb-3">
                          <Form.Label>Description Audio</Form.Label>
                          <Form.Control
                            type="file"
                            value={elementInArray?.[subDescAudioKey]}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                [subSabaqKey]: currentSubSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                          ...item,
                                          [subDescAudioKey]: e.target.files[0],
                                        }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Sabaq Name
                          </Form.Control.Feedback>
                        </div> */}

<>
                          {idEdit ? (
                            <>
                              <div className="row d-flex">
                                <div className="col-md-12">
                                  <label htmlFor="" className="key">
                                 Sub Sabaq Description Audio ({activeLangLabel})
                                  </label>
                                </div>
                                <div
                                  className={
                                    imageWidth === "100%"
                                      ? "d-none"
                                      : "col-md-6 "
                                  }
                                >
                                  <Form.Label>
                                    {typeof elementInArray?.[subDescAudioKey] ===
                                    "string"
                                      ? elementInArray?.[subDescAudioKey].substring(
                                        elementInArray?.[subDescAudioKey].length -
                                            15,
                                         elementInArray?.[subDescAudioKey].length
                                        )
                                      : ""}
                                  </Form.Label>
                                </div>
                                <div className="col-md-12 mb-3 ">
                                  <Form.Control
                                    type="file"
                                    accept="audio/mp3,audio/*;capture=microphone"
                                    name="sabaqImagePath"
                                    style={{ width: imageWidth.Description }}
                                  
                                    onChange={(e) => {
                                      setImageWidth({
                                        ...imageWidth,
                                        Description: "100%",
                                      });
                                      setAddNamaz({
                                        ...addNamaz,
                                        [subSabaqKey]: currentSubSabaq.map(
                                          (item, innerIndex) => {
                                            return index === innerIndex
                                              ? {
                                                  ...item,
                                                  [subDescAudioKey]:
                                                    e.target.files[0],
                                                }
                                              : item;
                                          }
                                        ),
                                      });
                                    }}
                                  />

                                  <Form.Control.Feedback type="invalid">
                                    Please Enter Sabaq Name
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                            </>
                          ) : (
                            <div className="col-md-12 mb-3">
                              <Form.Label>
                                Sub Sabaq Description Audio ({activeLangLabel})
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="audio/mp3,audio/*;capture=microphone"
                                name="sabaqImagePath"
                                //  / value={addSabaq?.sabaqAudio}
                                onChange={(e) => {
                                  setAddNamaz({
                                    ...addNamaz,
                                    [subSabaqKey]: currentSubSabaq.map(
                                      (item, innerIndex) => {
                                        return index === innerIndex
                                          ? {
                                              ...item,
                                              [subDescAudioKey]: e.target.files[0],
                                            }
                                          : item;
                                      }
                                    ),
                                  });
                                }}
                              />

                              <Form.Control.Feedback type="invalid">
                                Please Enter Sabaq Name
                              </Form.Control.Feedback>
                            </div>
                          )}
                        </>
                        
                        <div className="col-md-12 mb-3">
                          <Form.Label>
                            Sub Sabq Reference ({activeLangLabel})
                          </Form.Label>
                          <Form.Control
                            type="text"
                            dir={textDir}
                            value={elementInArray?.[subReferenceKey]}
                            onChange={(e) => {
                              setAddNamaz({
                                ...addNamaz,
                                [subSabaqKey]: currentSubSabaq.map(
                                  (item, innerIndex) => {
                                    return index === innerIndex
                                      ? {
                                          ...item,
                                          [subReferenceKey]: e.target.value,
                                        }
                                      : item;
                                  }
                                ),
                              });
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Reference
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      <div className="text-end">
                        <Link
                          // className="btn btn-danger"
                          // onClick={() => setAddNewGroup(AddNewGroup - 1)}
                          className={
                            currentSubSabaq.length > 1
                              ? "btn btn-danger"
                              : "btn btn-secondary invisible"
                          }
                          onClick={() => {
                            if (currentSubSabaq.length > 1) {
                              const copySubDeatails = [...currentSubSabaq];
                              copySubDeatails.splice(index, 1);
                              setAddNamaz({
                                ...addNamaz,
                                [subSabaqKey]: copySubDeatails,
                              });
                            }

                            // const copySubDeatails = [...addSabaq.subsabaqDetails];
                            // copySubDeatails.sli
                          }}
                        >
                          Remove
                        </Link>
                      </div>
                    </div>
                  );
                })}

              <Link
                to="#"
                className={
                  // idEdit
                  //   ? "add-newSabaq-btn invisible btn btn-secondary pe-none"
                  //   : 
                    "add-newSabaq-btn btn btn-primary"
                }
                // onClick={() => setAddNewGroup(AddNewGroup + 1)}

                onClick={() => {
                  let namaz = [...currentSubSabaq, emptySubSabaq()];
                  setAddNamaz({
                    ...addNamaz,
                    [subSabaqKey]: namaz,
                  });
                }}
              >
                + Add Sub Sabaq Details
              </Link>
            </div>
            <div className="buttons-modal border-top pt-3 text-end ">
              <button className="me-2" type="submit" disabled={saveBotton}>
                {idEdit === "edit" ? "update" : "Save"}
              </button>
              <Link
                to="#"
                className=" bg-danger"
                onClick={() => {
                  setAddNamaz(emptySabaq());
                  handleAddClose();
                  setIdEdit("");
                }}
              >
                Cancel
              </Link>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* ======================= END ADD ========================== */}

      {/* ======================= DELETE ========================== */}

      <Modal
        show={deleteModal}
        onHide={handleDeleteClose}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-msg text-center">
            <label htmlFor="">Are you sure you want to delete this item?</label>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <div className="buttons-modal    ">
            <button
              className="me-2 bg-danger"
              type="submit"
              onClick={()=>{
                handleDeleteClose()
                umrahLisDeleteApi()}}
            >
              Delete
            </button>
            <Link to="#" className="" onClick={handleDeleteClose}>
              Cancel
            </Link>
          </div>
        </Modal.Footer>
      </Modal>
      {/* ======================= END DELETE ========================== */}

      {/* ======================= VIEW ========================== */}
      <Modal
        show={viewModal}
        onHide={handleViewClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Umrah & Hajj Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="row">
              <div className="col-md-12 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq No.
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                    {viewDetails?.SabaqId}
                  </label>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Name
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                  {viewDetails?.sabaqName}
                  </label>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Audio
                  </label>
                </div>
                <div>
                  <audio controls style={{ width: "100%", height: "38px" }}>
                    <source src= {viewDetails?.sabaqAudio} type="audio/ogg" />
                    <source src= {viewDetails?.sabaqAudio}type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="" className="key">
                    Sabaq Description
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                  {viewDetails?.sabaqDesc}
                  </label>
                </div>
              </div>
              <div className="col-md-6 mb-3">
                <div className="mb-2">
                  <label htmlFor="" className="key">
                    Sabaq Description Audio
                  </label>
                </div>
                <div>
                  <audio controls style={{ width: "100%", height: "38px" }}>
                    <source src=  {viewDetails?.sabaqDescAudio} type="audio/ogg" />
                    <source src=  {viewDetails?.sabaqDescAudio} type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                </div>
              </div>

              <div className="col-md-12 mb-3">
                <div>
                  <label htmlFor="" className="key">
                   Sabaq Reference
                  </label>
                </div>
                <div>
                  <label htmlFor="" className="value">
                  {viewDetails?.sabaqDescReference}
                  </label>
                </div>
              </div>

              <h5 className="fw-bold">Sub Sabaq Details</h5>
              {viewDetails && viewDetails.subSabaqs && viewDetails.subSabaqs.length>0 &&
              viewDetails.subSabaqs.map((ele,index)=>{
                return(
                  <div className="sub-group-main row" key={"testkeyqwe"+index}>
                  <div className="col-md-6 mb-3">
                    <div>
                      <label htmlFor="" className="key">
                      Sub Sabaq Title {ele.subSabaqNo}
                      </label>
                    </div>
                    <div>
                      <label htmlFor="" className="value">
                    {ele?.subSabaqTitle}
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="mb-2">
                      <label htmlFor="" className="key">
                      Sub Sabaq Title Audio
                      </label>
                    </div>
                    <div>
                      <audio controls style={{ width: "100%", height: "38px" }}>
                        <source src= {ele?.titleAudioPath} type="audio/ogg" />
                        <source src= {ele?.titleAudioPath}type="audio/mpeg" />
                        Your browser does not support the audio element.
                      </audio>
                    </div>
                  </div>
  
                  <div className="col-md-6 mb-3">
                    <div>
                      <label htmlFor="" className="key">
                      Sub Sabaq Description
                      </label>
                    </div>
                    <div>
                      <label htmlFor="" className="value">
                      {ele?.subSabaqDesc}
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="mb-2">
                      <label htmlFor="" className="key">
                      Sub Sabaq Description Audio
                      </label>
                    </div>
                    <div>
                      <audio controls style={{ width: "100%", height: "38px" }}>
                        <source src=  {ele?.descAudioPath} type="audio/ogg" />
                        <source src=  {ele?.descAudioPath} type="audio/mpeg" />
                        Your browser does not support the audio element.
                      </audio>
                    </div>
                  </div>
                  <div className="col-md-12 mb-3">
                    <div>
                      <label htmlFor="" className="key">
                      Sub Sabaq Reference
                      </label>
                    </div>
                    <div>
                      <label htmlFor="" className="value">
                       {ele.descReference}
                      </label>
                    </div>
                  </div>
                </div>
                )
              })}
             
            </div>
            <div className="buttons-modal border-top pt-3 text-end ">
              <Link to="#" className="bg-danger" onClick={handleViewClose}>
                Cancel
              </Link>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* ======================= END VIEW ========================== */}
      {loader?<FormLoader/>:<div className="table-wrapper">
      <h6 >
            Total Records : {umrahList.length}
          </h6>
          <Table className="display" striped bordered hover size="lg">

          <thead>
            <tr>
              <th>Sabaq No.</th>
              <th style={{ textAlign: "left" }}>Sabaq List</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {umrahList && umrahList.length > 0
              ? umrahList.slice(startIndex, endIndex).map((ele, index) => {
                  return (
                    <tr key={"umrah"+index}>
                                                                    <td>{index + 1 + startIndex}</td>

                      <td style={{ textAlign: "left" }}>{ele.sabaqName}</td>
                      <td className="action">
                        <Link
                          to="#"
                          className="icon edit"
                          onClick={() => {
                            // handleAddShow();
                            setIdEdit("edit");
                            setImageWidth({
                              ...imageWidth,
                              sabaqAudio: "117px",
                              Uploade: "117px",
                              Tarjama: "117px",
                              Description: "117px",
                              subSabaqTitle: "117px",
                            });
                            EditListApi(ele.sabaqId);
                          }}
                        >
                          <img src={ic_edit} alt="" />
                        </Link>
                        <Link
                          to="#"
                          className="icon view"
                          onClick={() => viewDetailshandle(ele.sabaqId)}
                        >
                          <img src={ic_eyes} alt="" />
                        </Link>
                        <Link
                          to="#"
                          className="icon delete"
                          onClick={() => {
                            handleDeleteShow();
                            setDeleteId(ele.sabaqId);
                          }}
                        >
                          <img src={ic_delete} alt="" />
                        </Link>
                      </td>
                    </tr>
                  );
                })
              : ""}
          </tbody>
          </Table>
   {   umrahList && umrahList.length > 0
              ?   <Pagination
            changePage={changePage}
            pageCount={pageCount}
            currentPage={currentPage}

          
          />: (
            <div>
              <h5 style={{ color: "red", textAlign: "center" }}>
                {" "}
                Records Not Found
              </h5>
            </div>
          )}
      </div>}
    </main>
  );
};

export default UmrahHajj;
